import React from 'react';
import Avatar from 'react-avatar';

import Tooltip from '../../components/tooltip';

const profileColours = {
  '0': '#e0afde',
  '1': '#9ad2ff',
  '2': '#8dcece',
  '3': '#d1e297',
  '4': '#fff28c',
  '5': '#fed995',
  '6': '#ffc6db',
  '7': '#92f2dc',
};

function getNameBasedColour(name, min, max) {
  const firstLetter = name ? name[0].toLowerCase() : 'a';
  const charCode = firstLetter.charCodeAt(0);

  // ASCI char numbers from 97 to 122 for a to z char codes - change these into 0 to 8
  return Math.floor(charCode / 3.5 - 27);
}

function AvatarProfile(props) {
  const roleFormatted = props.role ? props.role.toLowerCase().replace('_', ' ') : null;
  if (props.plain) {
    return (
      <Avatar fgColor="#1D1937" name={props.name} round={true} color={profileColours[getNameBasedColour(props.name, 0, 8)]} size={props.size} />
    );
  }
  if (props.pending === true) {
    return (
      <div>
        { props.name ?
          <Tooltip content={ props.name } role={ roleFormatted } email={props.email} style="frame">
            <Avatar fgColor="#1D1937" name={props.name} round={true}  color="#e8e8eb" size={props.size} />
          </Tooltip>
        :
          <Avatar size={props.size} round={true} fgColor="#1D1937" color="#e8e8eb"  name="?" />
        }
      </div>
    );
  } else {
    if (props.noTooltip) {
      return (
        <Avatar fgColor="#1D1937" name={props.name} round={true} color={profileColours[getNameBasedColour(props.name, 0, 8)]} size={props.size} />
      );
    } else {
      return (
        <Tooltip content={props.name} role={roleFormatted} email={props.email} style="frame">
          <Avatar fgColor="#1D1937" name={props.name} round={true} color={profileColours[getNameBasedColour(props.name, 0, 8)]} size={props.size}/>
        </Tooltip>
      );
    }
  }
}

export default AvatarProfile;



/** WEBPACK FOOTER **
 ** ./src/components/avatar/index.js
 **/